import * as React from "react";

export const NoValue = (): JSX.Element => <span>-</span>;
